import { useEffect, useState } from "react";
import axios from "axios";
import { AdminCrud } from "./AdminCrud";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const useStoresOptions = () => {
  const [opts, setOpts] = useState([]);
  useEffect(() => { axios.get(`${API}/stores?include_inactive=true`).then((r) => setOpts((r.data.stores || []).map((s) => ({ value: s.id, label: s.nombre })))).catch(() => {}); }, []);
  return opts;
};

export const StoresAdmin = () => (
  <AdminCrud
    title="Tiendas" endpoint="/stores" listKey="stores" listParams="?include_inactive=true"
    columns={{ image: "logo_url", title: "nombre", subtitle: ["estatus", "ciudad"] }}
    fields={[
      { key: "nombre", label: "Nombre" },
      { key: "ciudad", label: "Ciudad" },
      { key: "estatus", label: "Estatus", type: "select", options: ["Oficial", "Aliada"], default: "Aliada" },
      { key: "direccion_texto", label: "Dirección" },
      { key: "lat", label: "Latitud", type: "number", step: "any" },
      { key: "lng", label: "Longitud", type: "number", step: "any" },
      { key: "maps_url", label: "URL Google Maps (opcional)", full: true },
      { key: "whatsapp", label: "WhatsApp principal (ej: 584129953694)" },
      { key: "whatsapp2", label: "WhatsApp secundario (opcional)" },
      { key: "instagram", label: "Instagram (usuario)" },
      { key: "facebook", label: "Facebook (URL completa)" },
      { key: "website", label: "Sitio web (URL)" },
      { key: "logo_url", label: "Logo", type: "image" },
      { key: "banner_url", label: "Banner", type: "image" },
      { key: "descripcion", label: "Descripción", type: "textarea", full: true, rows: 3 },
      { key: "activo", label: "Tienda activa (visible)", type: "checkbox", default: true },
    ]}
  />
);

export const NewsAdmin = () => {
  const stores = useStoresOptions();
  const [meta, setMeta] = useState({ categorias: [], juegos: [] });
  useEffect(() => { axios.get(`${API}/news/meta`).then((r) => setMeta(r.data)).catch(() => {}); }, []);
  return (
    <AdminCrud
      title="Noticias" endpoint="/news" listKey="posts" listParams="?include_unpublished=true&limit=100"
      columns={{ image: "imagen_portada", title: "titulo", subtitle: ["categoria", "juego", "fecha"] }}
      dynamicOptions={{ id_tienda: stores, categoria: meta.categorias, juego: meta.juegos }}
      fields={[
        { key: "titulo", label: "Título", full: true },
        { key: "categoria", label: "Categoría", type: "select", default: "Noticias" },
        { key: "juego", label: "Juego", type: "select", default: "Yu-Gi-Oh!" },
        { key: "fecha", label: "Fecha", type: "date" },
        { key: "id_tienda", label: "Tienda asociada", type: "select", optional: true },
        { key: "imagen_portada", label: "Imagen de portada", type: "image" },
        { key: "autor", label: "Autor" },
        { key: "resumen", label: "Resumen corto", type: "textarea", full: true, rows: 2 },
        { key: "contenido_markdown", label: "Contenido", type: "markdown", full: true, rows: 10 },
        { key: "decklist", label: "Decklist (opcional)", type: "decklist" },
        { key: "destacado", label: "Destacado", type: "checkbox", default: false },
        { key: "publicado", label: "Publicado", type: "checkbox", default: true },
      ]}
    />
  );
};

export const TorneosAdmin = () => {
  const stores = useStoresOptions();
  return (
    <AdminCrud
      title="Torneos" endpoint="/torneos" listKey="torneos" listParams="?include_inactive=true&limit=200"
      columns={{ image: "image", title: "name", subtitle: ["status", "date", "format"] }}
      dynamicOptions={{ id_tienda: stores }}
      fields={[
        { key: "name", label: "Nombre del torneo", full: true },
        { key: "image", label: "Flyer / Poster", type: "image" },
        { key: "status", label: "Estado", type: "select", options: [{ value: "proximo", label: "Próximo" }, { value: "finalizado", label: "Finalizado" }], default: "proximo" },
        { key: "date", label: "Fecha", type: "date" },
        { key: "time", label: "Hora (ej: 2:00 PM)" },
        { key: "format", label: "Formato (Avanzado, Edison, GOAT...)" },
        { key: "juego", label: "Juego", default: "Yu-Gi-Oh!" },
        { key: "id_tienda", label: "Tienda sede", type: "select", optional: true },
        { key: "location", label: "Ubicación / dirección" },
        { key: "entry_fee", label: "Inscripción (ej: $5)" },
        { key: "prizes", label: "Premios", full: true },
        { key: "max_participants", label: "Cupo máximo", type: "number" },
        { key: "current_participants", label: "Inscritos", type: "number", default: 0 },
        { key: "registration_url", label: "Link de inscripción (opcional)", full: true },
        { key: "winner", label: "Campeón (al finalizar)" },
        { key: "description", label: "Descripción", type: "markdown", full: true, rows: 6 },
        { key: "is_active", label: "Visible", type: "checkbox", default: true },
      ]}
    />
  );
};

export const SeasonsAdmin = () => {
  const [collections, setCollections] = useState([]);
  useEffect(() => { axios.get(`${API}/ranking/collections`, { withCredentials: true }).then((r) => setCollections((r.data.collections || []).map((c) => c.name || c))).catch(() => {}); }, []);
  return (
    <AdminCrud
      title="Temporadas" endpoint="/seasons" listKey="seasons"
      columns={{ title: "nombre", subtitle: ["collection_name", "fecha_inicio", "fecha_fin"] }}
      dynamicOptions={{ collection_name: collections }}
      fields={[
        { key: "nombre", label: "Nombre (ej: Temporada 2026)" },
        { key: "collection_name", label: "Colección de ranking en MongoDB", type: collections.length ? "select" : "text" },
        { key: "fecha_inicio", label: "Inicio", type: "date" },
        { key: "fecha_fin", label: "Fin", type: "date" },
        { key: "orden", label: "Orden (mayor = más reciente)", type: "number", default: 0 },
        { key: "es_actual", label: "Es la temporada actual", type: "checkbox", default: false },
        { key: "descripcion", label: "Descripción", type: "textarea", full: true, rows: 2 },
      ]}
    />
  );
};

export const TeamsAdmin = () => {
  const stores = useStoresOptions();
  return (
    <AdminCrud
      title="Equipos" endpoint="/teams" listKey="teams"
      columns={{ image: "logo_url", title: "nombre", subtitle: ["descripcion"] }}
      dynamicOptions={{ id_tienda: stores }}
      fields={[
        { key: "nombre", label: "Nombre del equipo" },
        { key: "logo_url", label: "Logo", type: "image" },
        { key: "aliases", label: "Alias (nombres como aparecen en los rankings)", type: "tags", full: true, placeholder: "Ad Astra, AdAstra Team" },
        { key: "miembros", label: "Miembros (nombres exactos de jugadores, opcional)", type: "tags", full: true },
        { key: "id_tienda", label: "Tienda asociada", type: "select", optional: true },
        { key: "descripcion", label: "Descripción", type: "textarea", full: true, rows: 2 },
      ]}
    />
  );
};
